import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { fetchkampeerplaatsenall } from "../../Reducers/actions";
import Loading from "../../../../Components/loading/load";
import ElectraWidget from "../Components/ElectraWidget";
function MeterInstellen({ kampeerplaatsen, fetchkampeerplaatsenall }) {
  const [load, setLoad] = useState(false);
  useEffect(() => {
    fetchkampeerplaatsenall(1000).then((data) => {
      setLoad(true);
    }, []);
  }, [load, fetchkampeerplaatsenall]);
  return (
    <div className="box box-default">
      <div className="box-header with-border">
        <h3 className="box-title"> Plaats Instellen</h3>
      </div>
      <Loading loadings={load} />
      {load && <ElectraWidget kampeerplaatsen={kampeerplaatsen} />}
    </div>
  );
}
function mapStateToProps(state) {
  return { user: state.auth.user, kampeerplaatsen: state.standplaatsen.kampeerplaatsen };
}
export default connect(mapStateToProps, { fetchkampeerplaatsenall })(MeterInstellen);
